import sidebar from '@/config/sidebars/gsc_ga4'
import createVueApp from '@/common/create_app'

Styxie.Initializers.GscGa4GscPages = {
  index: async(props) => {
    const { default: GscPagesIndex } = await import('@/vue_widgets/gsc_ga4/gsc_pages/index.vue')
    createVueApp(GscPagesIndex, { props, sidebar })
  }
}
